import * as Sentry from '@sentry/react';
import { jwtDecode } from 'jwt-decode';

export const setDefaultSentryTag = (token, appVersion = '') => {
    try {
        const decodedToken = jwtDecode(token);
        const jwt_id = decodedToken?.jwt_id || '';
        Sentry.setTags({
            jwt_id: jwt_id,
            APP_VERSION: appVersion,
        });
    } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
            Sentry.captureException(error, {
                tags: { method: 'setDefaultSentryTag' },
            });
        }
    }
};

export const clearSentry = () => {
    Sentry.setTag('jwt_id', null);
    Sentry.setTag('APP_VERSION', null);
};
